import React, { useCallback, useEffect, useState } from 'react';
import { Avatar, Box, Skeleton, Slider, Typography, Checkbox, FormControlLabel, Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import { deepOrange } from '@mui/material/colors';
import { getImageStore } from 'store/files';
import Cropper, { Area } from "react-easy-crop";
import { useFormikContext } from 'formik';
import { updateAvatarEmployeeStore } from 'store/uploaders';
import { ModalSessionExpired } from 'components/generics/ModalSessionExpired';
import MultipleSnackbars from 'components/MultipleSnackbars';
import { SnackAlert } from 'components/SnackAlert';
import { timeToClosedToast } from '../../../../commons';
import { validateResponse } from 'commons/utils';

export const EditarImgEmployeeActually = ({ urlImage, typeImage }: any) => {

    const dispatch = useDispatch();
    const formikProps: any = useFormikContext();


    const [editMode, setEditMode] = useState(false);
    const [logoUrl, setLogoUrl] = useState<string | null>(null);
    

    const [percentage_upload, setPercntageUpload]   = useState(0);




    {/* *****************************************************************
        ******  STATES PARA MANEJAR MENSAJES DEL RESPONSE  **************
        *********************************************************************/}
        const [alert_snack, setAlertSnack] = useState(false);
        const [msgSnack, setMsgSnack] = useState({
            msg: '',
            status: 'success'
        });
        const [timeAlert, setTimeAlert] = useState(timeToClosedToast);
        const [messagesAlerts, setMessagesAlerts] = useState<any>([]);
        const [modalSessionExpired, setModalSessionExpired] = useState(false);
    {/* ******************************************************************
        ******  STATES PARA MANEJAR MENSAJES DEL RESPONSE  **************
        *********************************************************************/}


    const getLogoImage = async (imageName: string) => {
        const response = await dispatch(getImageStore(imageName, typeImage));
        if (response instanceof Blob) {
            const imageUrl = URL.createObjectURL(response);
            setLogoUrl(imageUrl);
        }
    };

    // ==== Crop states ====
    const [cropPhoto, setCropPhoto] = useState({ x: 0, y: 0 });
    const [rotationPhoto, setRotationPhoto] = useState(0);
    const [croppedAreaPixelsPhoto, setCroppedAreaPixelsPhoto] = useState<Area>({
        x: 0,
        y: 0,
        width: 320,
        height: 240,
    });

    const onCropCompletePhoto = useCallback((_: Area, croppedArea: Area) => {
        setCroppedAreaPixelsPhoto(croppedArea);
    }, []);

    useEffect(() => {
        getLogoImage(urlImage);
    }, [urlImage]);



    const handleSavePhoto = async() => {

      console.log('Intentando guardar recorte...');
      
      const imageSrc = logoUrl;
      
      // Verificación más específica
      if (!croppedAreaPixelsPhoto || !imageSrc) {
        console.log('No se puede guardar - faltan datos:', {
          tieneCroppedArea: !!croppedAreaPixelsPhoto,
          tieneImagen: !!imageSrc,
          imagen: imageSrc
        });
        return;
      }

      // Verifica que croppedAreaPixelsPhoto tenga dimensiones válidas
      if (croppedAreaPixelsPhoto.width <= 0 || croppedAreaPixelsPhoto.height <= 0) {
        console.log('Dimensiones de recorte inválidas:', croppedAreaPixelsPhoto);
        return;
      }

      console.log('Procesando imagen...');
      
      const image = new Image();
      image.src = imageSrc;

      image.onload = () => {
        console.log('Imagen cargada, dimensiones:', image.width, 'x', image.height);
        
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        if (!ctx) {
          console.log('Error: No se pudo obtener el contexto 2D');
          return;
        }

        canvas.width = croppedAreaPixelsPhoto.width;
        canvas.height = croppedAreaPixelsPhoto.height;

        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate((rotationPhoto * Math.PI) / 180);
        ctx.translate(-canvas.width / 2, -canvas.height / 2);

        ctx.drawImage(
          image,
          croppedAreaPixelsPhoto.x,
          croppedAreaPixelsPhoto.y,
          croppedAreaPixelsPhoto.width,
          croppedAreaPixelsPhoto.height,
          0,
          0,
          croppedAreaPixelsPhoto.width,
          croppedAreaPixelsPhoto.height
        );

        canvas.toBlob( async(blob) => {
          if (blob) {
            const url = URL.createObjectURL(blob);
       


           const idEmployee =  formikProps.values.empleadoId;

           const result = await dispatch( updateAvatarEmployeeStore( 'avatar-employee',idEmployee, blob,  setPercntageUpload) );

           if( result.ok ){

                setEditMode(false);
                getLogoImage(result.data);

                await validateResponse(result, 'actualizar iamgen', {
                        setMsgSnack,
                        setAlertSnack,
                        setModalSessionExpired,
                    }, true );

           }
       
            
          } else {
            console.log('Error: No se pudo crear el blob del recorte');
          }
        }, "image/jpeg");
      };

      image.onerror = () => {
        console.log('Error al cargar la imagen');
      };
      
    };

    return (
        <>  


        {/* *****************************************************************
            ******  COMPONENTS PARA MANEJAR MENSAJES DEL RESPONSE  **************
            *********************************************************************/}
            <ModalSessionExpired  open={modalSessionExpired}  />
            <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />
            <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>
        {/* ******************************************************************
            ******  COMPONENTS PARA MANEJAR MENSAJES DEL RESPONSE  **************
            *********************************************************************/}


            {logoUrl ? (
                <Box 
                    sx={{ 
                        display: "flex", 
                        flexDirection: "column", 
                        alignItems: "center", 
                        gap: 2, 
                        width: "100%" 
                    }}
                >
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={editMode}
                                onChange={(_, checked) => setEditMode(checked)}
                                color="primary"
                            />
                        }
                        label="Editar esta imagen"
                    />

                    {editMode ? (
                        <>
                            {/* Contenedor del Cropper */}
                            <Box
                                sx={{
                                    position: "relative",
                                    width: 320,
                                    height: 240,
                                    borderRadius: 2,
                                    overflow: "hidden",
                                    boxShadow: 2,
                                    backgroundColor: "#fff",
                                }}
                            >
                                <Cropper
                                    image={logoUrl}
                                    crop={cropPhoto}
                                    zoom={formikProps.values.ed_set_zoom_photo || 1}
                                    rotation={formikProps.values.ed_set_rotation_photo || 0}
                                    aspect={4 / 3}
                                    objectFit="cover"
                                    onCropChange={setCropPhoto}
                                    onZoomChange={(z) => formikProps.setFieldValue("ed_set_zoom_photo", z)}
                                    onRotationChange={(r) => formikProps.setFieldValue("ed_set_rotation_photo", r)}
                                    onCropComplete={onCropCompletePhoto}
                                />
                            </Box>
                            {/* Slider de zoom */}
                            <Box sx={{ width: "60%", maxWidth: 300, display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <Typography gutterBottom align="center">Zoom</Typography>
                                <Slider
                                    value={formikProps.values.ed_set_zoom_photo || 1}
                                    min={1}
                                    max={3}
                                    step={0.1}
                                    onChange={(_, v) => formikProps.setFieldValue("ed_set_zoom_photo", v)}
                                    sx={{ width: "100%" }}
                                />
                                <Button
                                    variant="contained"
                                    color="success"
                                    onClick={handleSavePhoto}
                                    sx={{ mt: 2, alignSelf: "center" }}
                                >
                                    Recortar y guardar
                                </Button>
                            </Box>
                        </>
                    ) : (
                        <Avatar
                            sx={{ 
                                bgcolor: deepOrange[500], 
                                width: 320,
                                height: 240, 
                                textAlign: "center",
                                boxShadow: 2 
                            }}
                            alt="Avatar Empleado"  
                            src={logoUrl}
                            variant="square"
                        >
                            Q
                        </Avatar>
                    )}
                </Box>
            ) : (
                <Skeleton animation="wave" variant="rectangular" width={140} height={140} />
            )}
        </>
    );
};
